'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _initCustomNavFlickity = require('../helpers/initCustomNavFlickity');

var _initCustomNavFlickity2 = _interopRequireDefault(_initCustomNavFlickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components

// PDP Slider

document.addEventListener('DOMContentLoaded', function (event) {
  var ingredientsSwitchers = document.querySelectorAll('.ingredients-switcher');

  [].concat((0, _toConsumableArray3.default)(ingredientsSwitchers)).forEach(function (switcher) {
    // Elements
    var sliderContainer = switcher.querySelector('.ingredients-slider__container');
    var descriptionSliderContainer = switcher.querySelector('.ingredients-description-slider__container');
    var triggers = switcher.querySelectorAll('.ingredient-trigger');

    // Initialize the slider
    var imageSlider = (0, _initCustomNavFlickity2.default)(sliderContainer, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      fade: true,
      imagesLoaded: true,
      adaptiveHeight: true,
      draggable: true,
      wrapAround: true
    });

    // Initialize the description slider
    var descriptionSlider = (0, _initCustomNavFlickity2.default)(descriptionSliderContainer, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      fade: true,
      imagesLoaded: true,
      adaptiveHeight: true
    });

    // Trigger event listener
    [].concat((0, _toConsumableArray3.default)(triggers)).forEach(function (trigger, index) {
      trigger.addEventListener('mouseenter', function () {
        // Activate the image slide.
        // The image slide triggers all other changes.
        imageSlider.select(index);
      });
    });

    // Image slider change event listener
    imageSlider.on('change', function (index) {
      // Change the description slider.
      descriptionSlider.select(index);

      // Activate link
      [].concat((0, _toConsumableArray3.default)(triggers)).forEach(function (trigger, triggerIndex) {
        if (triggerIndex === index) {
          trigger.classList.add('active');
        } else {
          trigger.classList.remove('active');
        }
      });
    });
  });
}); /*----------------------------
    Scripts
    ----------------------------*/

// Helpers